module.exports = __webpack_public_path__ + "static/media/Sonaal.7dea991d.jpeg";